import React from 'react'
import { numberFormat } from '../../../helper'
import PropTypes from 'prop-types'
import FloatingFilterComponent from '../components/ModalFilters/FloatingFilterComponent'
import ModalFilterSearch from '../components/ModalFilters/ModalFilterSearch'
import {
  CheckboxTradeBlotter,
  CheckboxTradeBlotterHeader,
  TextQuantity
} from '../TradeBlotter.style'
import ModalFiltersSet from '../components/ModalFilters/ModalFiltersSet'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import { ReactComponent as DeselectedCheckBox } from '../../../assets/deSelectCheckbox.svg'
import ModalFilterDateSearch from '../components/ModalFilters/ModalFilterDateSearch'
import { Box, FormControlLabel, Skeleton, Typography } from '@mui/material'

import ModalFilterDate from '../components/ModalFilters/ModalFilterDate'
import { useMemo, useCallback } from 'react'
import Status from '../components/Status/Status'
import DehazeIcon from '@mui/icons-material/Dehaze'
import { STAGING_STATUS, TRADE_BLOTTER_STATUS } from '../../../utils/constants'
import { useRef } from 'react'

const useAgGridColumnSetting = ({
  tradesGroup,
  dealsGroup,
  dealTradesGroup,
  tradesGiveUp,
  tradesConversion,
  tradeBlotterResponse,
  setSelected,
  dealsGiveUpGroup,
  setSelectedAllDeal,
  checkBoxHeader,
  setCheckBoxHeader,
  setDealsGiveUpGroup,
  setDealsGroup,
  selectedAllDeal,
  selected,
  cleanCheckBoxState,
  filters,
  tradeDealTypeData,
  tradeCounterpartyData,
  tradeSymbolData,
  currencyData,
  fixingSourceData,
  timingData,
  makorPrimeBrokerData,
  tradeOriginData
}) => {
  const SkeletonCellRenderer = () => {
    return (
      <Skeleton
        variant="rectangular"
        width="100%"
        height={25}
        style={{ margin: '9px', borderRadius: '3px' }}
      />
    )
  }

  const ClientQuantity = prop => {
    const { client_quantity, isSkelton } = prop.data
    return isSkelton ? (
      <SkeletonCellRenderer />
    ) : (
      <TextQuantity quantity={client_quantity}>{numberFormat(client_quantity)}</TextQuantity>
    )
  }
  const FarQuantity = prop => {
    const { far_leg_quantity, isSkelton } = prop.data
    return isSkelton ? (
      <SkeletonCellRenderer />
    ) : (
      <TextQuantity quantity={far_leg_quantity}>{numberFormat(far_leg_quantity)}</TextQuantity>
    )
  }

  const MarketMakerQuantity = prop => {
    const { market_maker_quantity, isSkelton } = prop.data
    return isSkelton ? (
      <SkeletonCellRenderer />
    ) : (
      <TextQuantity quantity={market_maker_quantity}>
        {numberFormat(prop.data.market_maker_quantity)}
      </TextQuantity>
    )
  }

  const ValueDate = prop => {
    const { value_date, settlement_date, isSkelton } = prop.data
    return isSkelton ? (
      <SkeletonCellRenderer />
    ) : (
      <TextQuantity>{settlement_date || value_date}</TextQuantity>
    )
  }

  const CurrencyPairCell = prop => {
    const { base_currency, counter_currency, strike, expiry, put_call, cut, isSkelton } = prop.data

    const formattedText = `${base_currency}${counter_currency} ${expiry || ''} ${strike || ''} ${
      put_call ? put_call[0] : ''
    } ${cut || ''}`
    return isSkelton ? (
      <SkeletonCellRenderer />
    ) : (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%'
        }}
      >
        <Typography
          style={{
            fontSize: '14px'
          }}
        >
          {formattedText}
        </Typography>
      </Box>
    )
  }

  const handelChecked = useCallback(
    params => {
      if (Array.isArray(params.children)) {
        return Number(params.id) in dealsGroup
      } else {
        return (
          Number(params.id) in tradesGroup ||
          Number(params.id) in dealTradesGroup ||
          Number(params.id) in tradesGiveUp ||
          Number(params.id) in tradesConversion
        )
      }
    },
    [tradesGroup, dealsGroup, dealTradesGroup, tradesGiveUp, tradesConversion]
  )

  const MyHeaderComponent = props => {
    const { showColumnMenu } = props
    const handelCheckBoxHeaders = () => {
      if (Object.keys(dealsGroup).length === 0) {
        const deals = tradeBlotterResponse.data.filter(t => Array.isArray(t.children))
        setSelected(() => deals.length)
        const dealsGroupCopy = JSON.parse(JSON.stringify(dealsGroup))
        const dealsGiveUpGroupCopy = JSON.parse(JSON.stringify(dealsGiveUpGroup))
        for (const deal of deals) {
          const id = Number(deal.id)
          dealsGroupCopy[id] = deal
          if (
            deal.staging_status === STAGING_STATUS.PENDING &&
            [null, TRADE_BLOTTER_STATUS.NEW].includes(deal.status)
          ) {
            dealsGiveUpGroupCopy[id] = deal
          }
        }
        setSelectedAllDeal({ ...selectedAllDeal, status: true, signDeals: deals.length })
        setCheckBoxHeader(true)
        setDealsGiveUpGroup(dealsGiveUpGroupCopy)
        setDealsGroup(dealsGroupCopy)
      } else {
        setCheckBoxHeader(false)
        cleanCheckBoxState()
      }
    }
    const ref = useRef()

    const openMenu = e => {
      e.stopPropagation()
      showColumnMenu(e.currentTarget)
    }

    const handleMouseLeave = () => {
      ref.current.style.display = 'none'
    }

    const handleMouseEnter = () => {
      ref.current.style.display = 'block'
    }

    MyHeaderComponent.propTypes = {
      showColumnMenu: PropTypes.func
    }

    const condition =
      (selectedAllDeal.maxDeals === selected && selectedAllDeal.status) || selected === 0
    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'flex-start'
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {
          <FormControlLabel
            style={{ marginLeft: '-14px' }}
            control={
              <CheckboxTradeBlotterHeader
                icon={
                  condition ? (
                    <CheckBoxOutlineBlankIcon fontSize="small" />
                  ) : (
                    <DeselectedCheckBox fontSize="small" />
                  )
                }
                checkedIcon={
                  condition ? (
                    <CheckBoxIcon fontSize="small" />
                  ) : (
                    <DeselectedCheckBox fontSize="small" />
                  )
                }
              />
            }
            checked={checkBoxHeader}
            onClick={handelCheckBoxHeaders}
            label={`(${selected})`}
          />
        }

        <Typography className="ag-header-cell-text" style={{ textAlign: 'center', width: '100%' }}>
          Id
        </Typography>
        <DehazeIcon
          ref={ref}
          fontSize="small"
          onClick={openMenu}
          style={{
            display: 'none',
            marginLeft: 6,
            cursor: 'pointer'
          }}
        />
      </Box>
    )
  }

  const autoGroupColumnDef = {
    suppressCount: true,
    headerName: 'ID',
    padding: '0',
    filter: ModalFilterSearch,
    filterParams: {
      name: 'id',
      filters
    },
    showColumnMenu: true,
    headerComponent: MyHeaderComponent,
    floatingFilter: true,
    floatingFilterComponent: FloatingFilterComponent,
    cellRendererParams: {
      suppressCount: true,
      innerRenderer: params => {
        if (params.data.isSkelton) {
          return <></>
        }

        const disabledCondition =
          (Array.isArray(params.data.children) &&
            params.data.status === TRADE_BLOTTER_STATUS.DELETE) ||
          params.data.is_delete === 1

        return (
          <Box
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Status
              data={params.data}
              isDeal={Array.isArray(params.data.children)}
              tradeInsideADeal={
                !Array.isArray(params.data.children) ? params.data.deal_id === null : false
              }
            />
            <CheckboxTradeBlotter
              insideDeal={params.data.inside_deal}
              checked={handelChecked(params.data)}
              disabled={disabledCondition}
            />
            <Typography
              style={{
                position: 'absolute',
                left: '58%',
                top: '22%',
                fontSize: '14px'
              }}
            >
              {params.data.id}
            </Typography>
          </Box>
        )
      }
    },
    valueFormatter: params => {
      return params.data.id
    }
  }

  const defaultColDef = useMemo(
    () => ({
      fontSize: '14px',
      resizable: true,
      sortable: true,
      wrapText: false,
      autoHeight: false
    }),
    []
  )
  const columnsDefs = useMemo(
    () => [
      {
        headerName: 'Trade Date',
        field: 'trade_date',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.trade_date,
        filter: ModalFilterDate,
        floatingFilter: true,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name1: 'trade_date_start',
          name2: 'trade_date_end',
          filters
        }
      },
      {
        headerName: 'Type',
        field: 'type',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.type,
        floatingFilter: true,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'types',
          values: tradeDealTypeData?.data?.map(({ name }) => name),
          filters
        }
      },
      {
        headerName: 'Client',
        field: 'client',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.client,
        floatingFilter: true,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'clients',
          values: tradeCounterpartyData?.data?.map(({ name }) => name),
          filters
        }
      },
      {
        headerName: 'Market Maker',
        field: 'market_maker',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.market_maker,
        floatingFilter: true,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'market_makers',
          values: tradeCounterpartyData?.data?.map(({ name }) => name),
          filters
        }
      },
      {
        headerName: 'Symbol',
        field: 'symbol',
        floatingFilter: true,
        cellRenderer: CurrencyPairCell,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'symbols',
          values: tradeSymbolData?.data?.map(({ symbol }) => symbol),
          filters
        }
      },
      {
        headerName: 'Value Date',
        field: 'value_date',
        floatingFilter: true,
        cellRenderer: ValueDate,
        filter: ModalFilterDate,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name1: 'value_date_start',
          name2: 'value_date_end',
          filters
        }
      },
      {
        headerName: 'Client Qty',
        field: 'client_quantity',
        floatingFilter: true,
        cellRenderer: ClientQuantity,
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'client_quantity',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'Client Price',
        field: 'client_price',
        cellRenderer: params =>
          params.data.isSkelton ? (
            <SkeletonCellRenderer />
          ) : (
            numberFormat(params.data.client_price, 6)
          ),
        floatingFilter: true,
        floatingFilterComponent: FloatingFilterComponent,
        filter: ModalFilterSearch,
        filterParams: {
          name: 'client_price',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'MM Qty',
        field: 'market_maker_quantity',
        floatingFilter: true,
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        cellRenderer: MarketMakerQuantity,
        filterParams: {
          name: 'market_maker_quantity',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'MM Price',
        field: 'market_maker_price',
        cellRenderer: params =>
          params.data.isSkelton ? (
            <SkeletonCellRenderer />
          ) : (
            numberFormat(params.data.market_maker_price, 6)
          ),
        floatingFilter: true,
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'market_maker_price',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'Far Quantity',
        field: 'far_leg_quantity',
        floatingFilter: true,
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        cellRenderer: FarQuantity,
        filterParams: {
          name: 'far_leg_quantity',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'Far Price',
        field: 'far_price',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : numberFormat(params.data.far_price, 6),
        floatingFilter: true,
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'far_price',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'Far Value Date',
        field: 'far_value_date',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.far_value_date,
        floatingFilter: true,
        filter: ModalFilterDateSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'far_value_date',
          filters
        }
      },
      {
        headerName: 'P&L USD',
        field: 'pnl_usd_live',
        cellRenderer: params =>
          params.data.isSkelton ? (
            <SkeletonCellRenderer />
          ) : params.data.pnl_usd_live !== undefined ? (
            <TextQuantity quantity={params.data.pnl_usd_live}>
              {numberFormat(params.data.pnl_usd_live)}
            </TextQuantity>
          ) : (
            '-'
          )
      },
      {
        headerName: 'Lower Barrier',
        field: 'lower_barrier',
        cellRenderer: params =>
          params.data.isSkelton ? (
            <SkeletonCellRenderer />
          ) : (
            numberFormat(params.data.lower_barrier)
          ),
        floatingFilter: true,
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'lower_barrier',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'Upper Barrier',
        field: 'upper_barrier',
        cellRenderer: params =>
          params.data.isSkelton ? (
            <SkeletonCellRenderer />
          ) : (
            numberFormat(params.data.upper_barrier)
          ),
        floatingFilter: true,
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'upper_barrier',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'Premium',
        field: 'premium_amount',
        cellRenderer: params => {
          if (params.data.isSkelton) {
            return <SkeletonCellRenderer />
          } else if (params.data.side === 'BUY' && params.data.premium_amount) {
            return numberFormat(-1 * params.data.premium_amount)
          } else if (params.data.side === 'SELL' && params.data.premium_amount) {
            return numberFormat(params.data.premium_amount)
          } else if (params.data.premium_amount) {
            return numberFormat(params.data.premium_amount)
          }
        },
        floatingFilter: true,
        cellStyle: params => {
          if (params.data.side === 'BUY' || params.data.premium_amount < 0) {
            return { color: '#FD7557' }
          }
          return { color: 'white' }
        },
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'premium_amount',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'Premium Currency',
        field: 'premium_currency',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.premium_currency,
        floatingFilter: true,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'premium_currency',
          values: currencyData?.data?.map(({ name }) => name),
          filters
        }
      },
      {
        headerName: 'Premium Date',
        field: 'premium_date',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.premium_date,
        floatingFilter: true,
        filter: ModalFilterDateSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'premium_date',
          filters
        }
      },
      {
        headerName: 'Note',
        field: 'note',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.note
      },
      {
        headerName: 'Fixing Date',
        field: 'fix_source_date',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.fix_source_date,
        floatingFilter: true,
        filter: ModalFilterDateSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'fix_source_date',
          filters
        }
      },
      {
        headerName: 'Fixing Source',
        field: 'fixing_source',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.fixing_source,
        filter: ModalFiltersSet,
        floatingFilter: true,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'fixing_source',
          values: fixingSourceData?.data?.map(({ name }) => name),
          filters
        }
      },
      {
        headerName: 'Payout Amount',
        field: 'payout_amount',
        cellRenderer: params =>
          params.data.isSkelton ? (
            <SkeletonCellRenderer />
          ) : (
            <TextQuantity quantity={params.data.payout_amount}>
              {numberFormat(params.data.payout_amount)}
            </TextQuantity>
          ),
        floatingFilter: true,
        filter: ModalFilterSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'payout_amount',
          filters,
          placeholder: '0.00'
        }
      },
      {
        headerName: 'Payout Currency',
        field: 'payout_currency',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.payout_currency,
        floatingFilter: true,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'payout_currency',
          values: currencyData?.data?.map(({ name }) => name),
          filters
        }
      },
      {
        headerName: 'Timing',
        field: 'timing',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.timing,
        floatingFilter: true,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'timing',
          values: timingData?.data?.map(({ name }) => name),
          filters
        }
      },
      {
        headerName: 'Window Start',
        field: 'window_start',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.window_start,
        floatingFilter: true,
        filter: ModalFilterDateSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'window_start',
          filters
        }
      },
      {
        headerName: 'Window End',
        field: 'window_end',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.window_end,
        floatingFilter: true,
        filter: ModalFilterDateSearch,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'window_end',
          filters
        }
      },
      {
        headerName: 'PB Mapping Value',
        field: 'prime_broker_mapping',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.prime_broker_mapping
      },
      {
        headerName: 'Prime Broker',
        field: 'makor_prime_broker',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.makor_prime_broker,
        floatingFilter: true,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'makor_prime_broker',
          values: makorPrimeBrokerData?.data?.map(({ name }) => name),
          filters
        }
      },

      {
        headerName: 'Fee',
        field: 'fee',
        cellRenderer: params => (params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.fee)
      },
      {
        headerName: 'Dollar Notional',
        field: 'dollar_notional',
        cellRenderer: params =>
          params.data.isSkelton ? (
            <SkeletonCellRenderer />
          ) : params.data.dollar_notional !== undefined ? (
            numberFormat(params.data.dollar_notional)
          ) : (
            '-'
          )
      },
      {
        headerName: 'Direction',
        field: 'direction',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.direction
      },
      {
        headerName: 'Origin',
        field: 'origin',
        cellRenderer: params =>
          params.data.isSkelton ? <SkeletonCellRenderer /> : params.data.origin,
        floatingFilter: true,
        filter: ModalFiltersSet,
        floatingFilterComponent: FloatingFilterComponent,
        filterParams: {
          name: 'origin',
          values: tradeOriginData?.data?.map(({ name }) => name),
          filters
        }
      }
    ],
    [
      filters,
      tradeDealTypeData?.data,
      tradeCounterpartyData?.data,
      tradeSymbolData?.data,
      currencyData?.data,
      fixingSourceData?.data,
      timingData?.data,
      makorPrimeBrokerData?.data,
      tradeOriginData?.data
    ]
  )

  return { columnsDefs, defaultColDef, autoGroupColumnDef }
}

export default useAgGridColumnSetting
